import { ROUTER_PATHS } from 'src/paths';
import type { CareerHubCountry } from 'src/types';

import translations from './.vocab';
import { getTranslations } from './translations';

const t = getTranslations(translations);

export interface MetaDataInput {
  page: string;
  groupTitle?: string;
  threadTitle?: string;
  absoluteUrl: string;
  language: string;
  countryCode?: CareerHubCountry;
}

export interface MetaData {
  title: string;
  description: string;
  absoluteUrl: string;
}

const MAX_TITLE_LENGTH = 39;

const getThreadTitle = (threadTitle: string = ''): string => {
  if (threadTitle.length < MAX_TITLE_LENGTH) {
    return threadTitle;
  }
  return `${threadTitle.substring(0, MAX_TITLE_LENGTH)}...`;
};

export const getMetaData = ({
  page,
  groupTitle,
  threadTitle,
  absoluteUrl,
  language,
  countryCode,
}: MetaDataInput): MetaData => {
  const absoluteUrlWithoutQueryParams = absoluteUrl.split('?')[0];

  switch (page) {
    case ROUTER_PATHS.communityHome:
      return {
        title: t(language, 'communityTitle'),
        description: t(language, 'communityDescription'),
        absoluteUrl: absoluteUrlWithoutQueryParams,
      };
    case ROUTER_PATHS.communityGroups:
      return {
        title: t(language, `communityGroupsTitle-${countryCode}`),
        description: '',
        absoluteUrl: absoluteUrlWithoutQueryParams,
      };
    case ROUTER_PATHS.communityGroupsDetails:
      return {
        title: t(language, '{groupTitle} | JobStreet', { groupTitle }),
        description: '',
        absoluteUrl: absoluteUrlWithoutQueryParams,
      };
    case ROUTER_PATHS.communityThreadDetails:
      return {
        title: t(language, '{threadTitle} Forum Community | JobStreet', {
          threadTitle: getThreadTitle(threadTitle),
        }),
        description: '',
        absoluteUrl: absoluteUrlWithoutQueryParams,
      };
    default:
      return {
        title: t(language, 'communityTitle'),
        description: t(language, 'communityDescription'),
        absoluteUrl: absoluteUrlWithoutQueryParams,
      };
  }
};
